define(["require", "exports", "jquery", "knockout", "log", "viewer", "../../utils/tools", "../../models/UserContext", "../../models/CustomerImageModel"], function (require, exports, $, ko, log, Viewer, tools, UserContext, CustomerImageModel) {
    "use strict";
    var CustomerImages = /** @class */ (function () {
        function CustomerImages(customerId) {
            this.userCanViewImages = ko.observable(UserContext.hasAccess("Admin,CustomerImages.View,CustomerImages.Edit,CustomerImages.Delete"));
            this.userCanEditImages = ko.observable(UserContext.hasAccess("Admin,CustomerImages.Edit,CustomerImages.Delete"));
            this.userCanDeleteImages = ko.observable(UserContext.hasAccess("Admin,CustomerImages.Delete"));
            this.editCustomerImageModel = ko.observable(new CustomerImageModel());
            this.customerId = ko.observable(0);
            this.uploadComplete = ko.observable(false);
            this.btn = ko.observable();
            this.lastUploadId = ko.observable();
            this.lastLocationId = ko.observable();
            this.customerLocationArray = ko.observableArray([]);
            this.rotationAngle = ko.observable(0);
            var self = this;
            self.customerId(customerId);
        }
        CustomerImages.prototype.rotateImage = function (angle) {
            var self = this;
            var finalAngle = self.rotationAngle() + angle;
            if (finalAngle >= 360) {
                self.rotationAngle(0);
            }
            else {
                self.rotationAngle(finalAngle);
            }
            $("#imagePreview").css({
                '-webkit-transform': "rotate(" + finalAngle + "deg)",
                '-moz-transform': "rotate(" + finalAngle + "deg)",
                '-ms-transform': "rotate(" + finalAngle + "deg)",
                '-o-transform': "rotate(" + finalAngle + "deg)",
                'transform': "rotate(" + finalAngle + "deg)",
                'zoom': 1
            });
        };
        CustomerImages.prototype.initImages = function () {
            var self = this;
            if (self.userCanViewImages()) {
                self.loadImages(null);
                /*$(".add-image").on("click", event => {
                    self.editCustomerImage(0, self.customerId());
                    event.preventDefault();
                });*/
                $("#customerImages").on("click", ".btn-remove-image", function (event) {
                    var imageId = $(this).data("id");
                    self.deleteCustomerImageConfirm(imageId);
                    event.preventDefault();
                }).on("click", ".btn-edit-image", function (event) {
                    var imageId = $(this).data("id");
                    self.editCustomerImage(imageId, self.customerId());
                    event.preventDefault();
                });
            }
        };
        CustomerImages.prototype.addCustomerImage = function () {
            this.editCustomerImage(0, this.customerId());
        };
        CustomerImages.prototype.editCustomerImage = function (id, customerId) {
            var self = this;
            self.customerId(customerId);
            var title = "Add Image";
            if (id > 0) {
                title = "Edit Image";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (id === 0 && self.uploadComplete() === false) {
                        tools.error("No image selected!");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.btn(event.currentTarget);
                    var vis = $(".k-upload .k-file", modal).is(":visible");
                    if (vis === false) {
                        var obj_1 = ko.mapping.toJS(self.editCustomerImageModel);
                        tools.ajaxPost({
                            url: "/CustomerImages/UploadImage",
                            data: {
                                id: self.customerId(),
                                imageId: obj_1.Id,
                                locationId: obj_1.LocationId,
                                description: obj_1.Description,
                                angle: self.rotationAngle()
                            }
                        }).done(function (result) {
                            if (result.Success) {
                                tools.success("Changes updated successfully");
                                self.loadImages(self.lastLocationId());
                                self.loadImages(null);
                                self.loadImages(obj_1.LocationId);
                                $(modal).modal("hide");
                                return;
                            }
                            else {
                                tools.error(result.Error);
                            }
                        }).always(function () {
                            $(event.currentTarget).button("reset");
                        });
                    }
                    else {
                        $(".k-upload-selected", modal).click();
                    }
                },
                opened: function (modal) {
                    var getModelCall = null;
                    self.rotationAngle(0);
                    var locLookup = self.getCustomerLocationsLookup();
                    if (id > 0) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerImages/GetCustomerImageById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editCustomerImageModel(new CustomerImageModel(result.Data));
                                    self.lastLocationId(self.editCustomerImageModel().LocationId());
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editCustomerImageModel(new CustomerImageModel);
                        self.editCustomerImageModel().CustomerId(self.customerId());
                    }
                    $.when(getModelCall, locLookup).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'c-image-edit-template', data: editCustomerImageModel }\"></div>");
                        ko.applyBindings(self, modal);
                        if (id > 0 && data[0]) {
                            $("#imagePreview", modal).css("background-image", "url(/Upload/customerImages/thumb/_th" + data[0].Data.ImageChangedName + "?=" + Math.floor((Math.random() * 100000) + 1) + ")");
                        }
                        else {
                            self.rotationAngle(0);
                            $("#imagePreviewForm", modal).hide();
                        }
                        $(".btn-rotate", modal).on("click", function () {
                            setTimeout(function () { self.rotateImage(90); }, 65);
                        });
                        $("#customerImage", modal).kendoUpload({
                            async: {
                                saveUrl: "/CustomerImages/UploadImage",
                                autoUpload: false
                            },
                            multiple: false,
                            select: function (e) {
                                var files = e.files;
                                var error = false;
                                ko.utils.arrayForEach(files, function (file) {
                                    if (!(/\.(gif|jpg|jpeg|tiff|png)$/i).test(file.extension.toLowerCase())) {
                                        tools.error("Only image files can be uploaded!");
                                        error = true;
                                        e.preventDefault();
                                    }
                                });
                                if (error) {
                                    return;
                                }
                                $("#imagePreviewForm").show();
                                var fileReader = new FileReader();
                                fileReader.onload = function (event) {
                                    console.log(event);
                                    var mapImage = event.target.result;
                                    $("#imagePreview", modal).css("background-image", "url(" + mapImage + ")");
                                };
                                fileReader.readAsDataURL(e.files[0].rawFile);
                                setTimeout(function () {
                                    $(".k-upload-selected", modal).hide();
                                }, 10);
                                self.uploadComplete(true);
                            },
                            upload: function (e) {
                                e.data = {
                                    id: self.customerId(),
                                    imageId: id,
                                    description: self.editCustomerImageModel().Description(),
                                    locationId: self.editCustomerImageModel().LocationId(),
                                    angle: self.rotationAngle()
                                };
                            },
                            localization: {
                                select: "Drag or Select an image"
                            },
                            success: function (e) {
                                if (e.response && !e.response.Success) {
                                    tools.error(e.response.Error);
                                }
                                $(self.btn()).button("reset");
                                $(modal).modal("hide");
                                self.loadImages(self.editCustomerImageModel().LocationId());
                                self.loadImages(null);
                            }
                        });
                    });
                }
            });
        };
        CustomerImages.prototype.getCustomerLocationsLookup = function () {
            var self = this;
            return tools.ajaxGet({
                url: "/CustomerImages/GetLookupCustomerLocations?customerId=" + self.customerId(),
                success: function (data) {
                    if (data.Success) {
                        self.customerLocationArray.remove(function () { return true; });
                        for (var i = 0; i < data.Data.length; i++) {
                            var item = data.Data[i];
                            self.customerLocationArray.push(item);
                        }
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        CustomerImages.prototype.deleteCustomerImage = function (imageId) {
            var self = this;
            $.ajax({
                url: "/CustomerImages/DeleteCustomerImage",
                type: "POST",
                data: { imageId: imageId },
                success: function (d) {
                    tools.success("Customer image deleted successfully");
                    self.loadImages(d.locationId);
                    self.loadImages(null);
                },
                error: tools.ajaxFailed
            });
        };
        CustomerImages.prototype.deleteCustomerImageConfirm = function (imageId) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Image",
                text: "Are you sure you want to delete customer image?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerImage(imageId);
            });
        };
        CustomerImages.prototype.loadImages = function (locationId) {
            var self = this;
            var elem = "#customerImages";
            if (locationId > 0) {
                elem += locationId;
            }
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/CustomerImages/GetUploadImages",
                        dataType: "json",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            data.locationId = locationId;
                            return data;
                        }
                    }
                }
            });
            var galleryId = "customerImages";
            if (locationId) {
                galleryId = galleryId + locationId;
            }
            $(elem).kendoListView({
                autoBind: false,
                dataSource: dataSource,
                template: kendo.template($("#images-list-view").html()),
                dataBound: function (e) {
                    if (self.userCanEditImages()) {
                        $("#customerImages .btn-edit-image").show();
                    }
                    if (self.userCanDeleteImages()) {
                        $("#customerImages .btn-remove-image").show();
                    }
                    var options = {
                        url: "data-original",
                        ready: function (event) {
                            // 2 methods are available here: "show" and "destroy".
                            $(".customerImages .viewer-canvas").on("click", function (event) {
                                if (event.currentTarget === event.target) {
                                    self.galleryViewer.hide();
                                }
                            });
                            log.log('ready: ', event);
                        },
                        shown: function (event) {
                            // 9 methods are available here: "hide", "view", "prev", "next", "play", "stop", "full", "exit" and "destroy".
                            log.log('shown: ', event);
                        },
                        viewed: function (event) {
                            // All methods are available here except "show".
                            log.log('viewed: ', event);
                            $(".customerImages .viewer-desc").remove();
                            var image = e.sender.dataSource.at(event.detail.index);
                            if (image) {
                                $("<div class='viewer-desc'>".concat(image.Description, "</div>")).insertAfter($(".customerImages .viewer-title"));
                            }
                        }
                    };
                    self.galleryViewer = new Viewer(document.getElementById(galleryId), options);
                }
            });
            if ($(elem).length) {
                $(elem).data("kendoListView").dataSource.read();
            }
            else {
                $("#customerImages").data("kendoListView").dataSource.read();
            }
        };
        return CustomerImages;
    }());
    return CustomerImages;
});
//# sourceMappingURL=customerImages.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerImages.js
// module id = 41
// module chunks = 2